import {Component, OnInit, Input} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {SearchGrantsService} from "../services/search-grants.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Auth2Service} from "../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {jsPDF} from 'jspdf';
import {autoTable} from 'jspdf-autotable';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-search-grants-details',
  templateUrl: './search-grants-details.component.html',
  styleUrls: ['./search-grants-details.component.scss'],
  standalone: false
})
export class SearchGrantsDetailsComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Search Grants', path: 'app/search/grants'},
    { label: 'View Grant Details'}
  ]

  elementTags: any[] = [
    {
      "id": "grant-general-info-id",
      "name": "Grant Info",
      "selected": false
    },
    {
      "id": "donor-info-id",
      "name": "Donor Info",
      "selected": false
    },
    {
      "id": "donor-finances-id",
      "name": "Donor Finances",
      "selected": false
    },
    {
      "id": "donor-key-staff-id",
      "name": "Donor Key Staff",
      "selected": false
    }
  ];

  @Input()
  row: any;

  //To get the recipient details and cash grant amount
  donorRecipientMapping: any = null;

  recipientCompanyName: string = '';
  recipientEin: string = 'N/A';
  recipientCashAmtGrantFormatted: string = '';
  recipientDonorPurposeTxt: string = '';
  recipientWebsiteUrl: string = '';
  recipientStreetAddress: string = '';
  recipientCity: string = '';
  recipientState: string = '';
  recipientCountry: string = '';
  recipientZipCode: string = '';
  recipientAllCauses: string[] = [];

  donorDetailsRecord: any = null;

  donorOverviewRecord: any = null;

  companyName = '';

  truncMaxLength = 300;

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  emailCodeVerifiedFlag: string = 'N';
  //Needs pop up for Grant Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private searchGrantsService: SearchGrantsService,
              private routerChild: Router, private route: ActivatedRoute,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy View Grants Details")
  }

  ngOnInit(): void {
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName()
    // @ts-ignore
    const donorRecipientMappingId: string = this.route.snapshot.paramMap.get('donorRecipientMappingId');

    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.emailCodeVerifiedFlag = this.auth2ServiceChild.getEmailCodeVerifiedFlag();
    if (this.emailCodeVerifiedFlag != 'Y') {
      this.routerChild.navigateByUrl('app/users/emails/verify')
      return;
    } else {
      //Query the Details of the Recipient
      //Query the Details of the Grant, which contains the Donor Name, Cash Grant Amount, Purpose
      // @ts-ignore
      this.searchGrantsService.searchDonorRecipientDetails(donorRecipientMappingId, this.username)
        .subscribe((result: any) => {
          if (result && result.body) {
            this.donorRecipientMapping = result.body;
            // @ts-ignore
            this.searchGrantsService.searchDonorDetails(this.donorRecipientMapping['organizationDetailsId'], this.username)
              .subscribe((result2: any) => {
                if (result2 && result2.body) {
                  this.donorDetailsRecord = result2.body;
                  this.recipientCompanyName = this.donorRecipientMapping['recipientDto']['companyName'];
                  this.recipientEin = this.apiService.formatEin(this.donorRecipientMapping['recipientDto']['ein'])
                  this.recipientCashAmtGrantFormatted = this.donorRecipientMapping['cashAmtGrantFormatted'];
                  this.recipientDonorPurposeTxt = this.donorRecipientMapping['purposeTxt'];
                  this.recipientWebsiteUrl = this.donorRecipientMapping['recipientDto']['websiteUrlTxt'];
                  if (this.recipientWebsiteUrl == 'N/A' || this.recipientWebsiteUrl == 'n/a' || !this.recipientWebsiteUrl) {
                    this.recipientWebsiteUrl = 'N/A';
                  } else {
                    if (!this.recipientWebsiteUrl.startsWith('http')) {
                      this.recipientWebsiteUrl = 'https://' + this.recipientWebsiteUrl
                    }
                  }
                  this.recipientStreetAddress = this.donorRecipientMapping['recipientDto']['streetAddress'];
                  this.recipientCity = this.donorRecipientMapping['recipientDto']['city'];
                  this.recipientState = this.donorRecipientMapping['recipientDto']['state'];
                  this.recipientCountry = this.donorRecipientMapping['recipientDto']['country'];
                  this.recipientZipCode = this.donorRecipientMapping['recipientDto']['zipCode'];
                  this.recipientAllCauses = this.donorRecipientMapping['recipientDto']['otherCauseIds'];
                  // @ts-ignore
                  this.searchGrantsService.searchDonorOverview(this.donorDetailsRecord['nonprofitDonorId'], this.username)
                    .subscribe((result3: any) => {
                      if (result3 && result3.body) {
                        this.donorOverviewRecord = result3.body;
                        if (this.donorOverviewRecord['websiteURL'] == 'N/A' || this.donorOverviewRecord['websiteURL'] == 'n/a' || !this.donorOverviewRecord['websiteURL']) {
                          this.donorOverviewRecord['websiteURL'] = 'N/A';
                        } else {
                          if (!this.donorOverviewRecord['websiteURL'].startsWith('http')) {
                            this.donorOverviewRecord['websiteURL'] = 'https://' + this.donorOverviewRecord['websiteURL']
                          }
                        }
                        if (!this.donorOverviewRecord['taxFilingCountry']) {
                          this.donorOverviewRecord['taxFilingCountry'] = 'USA';
                        }
                      }
                    }, (err3: HttpErrorResponse) => {
                      this.redirectToLogin(err3);
                      this.pageErrorMessages.push({
                        field: 'Donor API Error',
                        detail: 'Failed to pull Donor overview...',
                        severity: 'error'
                      });
                      this.showErrorMessagesToUser();
                    })
                }
              }, (err2 : HttpErrorResponse) => {
                this.redirectToLogin(err2);
                this.pageErrorMessages.push({
                  field: 'Donor API Error',
                  detail: 'Failed to pull Donor Details...',
                  severity: 'error'
                });
                this.showErrorMessagesToUser();
              })
          }
          //loading icon = false
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Donor API Error',
            detail: 'Failed to pull Grant and Recipient Details...',
            severity: 'error'
          });
          this.showErrorMessagesToUser();
        })
    }
  }
  onBack() {
    this.routerChild.navigateByUrl('app/search/grants');
  }
  onViewDonorDetails() {
    this.routerChild.navigateByUrl('app/search/grants/donors/'+ this.donorOverviewRecord['nonprofitDonorId'] + '/details');
  }
  formatZipCode(inputStr: string): string {
    return this.apiService.formatZipCode(inputStr);
  }
  formatPhoneNumber(inputStr: string): string {
    return this.apiService.formatPhoneNumber(inputStr);
  }

  generateSearchablePdf() {
    // Create a new PDF document.
    const doc = new jsPDF();
    let now = new Date();
    const img = new Image();
    img.src = 'assets/images/Scalanthropy_logo.png'
    let y: number = 10;
    doc.addImage(img, 'PNG', 10, y, 50, 20);

    y = y + 30;
    doc.setFontSize(16).setFont("Helvetica", "bold").text("Grant Information:", 10, y)
    y = y + 10;
    doc.setFontSize(12);
    let recipientCompanyNameLabelText: string = "Company Name: ";
    doc.setFont("Helvetica", "bold").text(recipientCompanyNameLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.recipientCompanyName, 55, y);
    y = y + 10;
    let recipientEinLabelText: string = "EIN: ";
    doc.setFont("Helvetica", "bold").text(recipientEinLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.recipientEin, 55, y);
    y = y + 10;
    let recipientGrantAmtLabelText: string = "Grant Amount: ";
    doc.setFont("Helvetica", "bold").text(recipientGrantAmtLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.recipientCashAmtGrantFormatted, 55, y);
    y = y + 10;
    let recipientPurposeLabelText: string = "Purpose Text: ";
    if (this.recipientDonorPurposeTxt == null || this.recipientDonorPurposeTxt == '') {
      this.recipientDonorPurposeTxt = 'N/A';
    }
    let purposeTxtLength: number = this.recipientDonorPurposeTxt.length;
    if (purposeTxtLength > 55) {
      //Build array of string for the sake of line wrapping
      let h: number = 0;
      let truncLength: number = 0;
      let truncDonorPurposeTxt: string = '';
      if (purposeTxtLength >= this.truncMaxLength) {
        truncDonorPurposeTxt = this.recipientDonorPurposeTxt.slice(0, this.truncMaxLength);
        truncLength = this.truncMaxLength;
      } else {
        truncDonorPurposeTxt = this.recipientDonorPurposeTxt;
        truncLength = purposeTxtLength;
      }
      let linesMax: number = Math.ceil(truncLength / 55);
      doc.setFont("Helvetica", "bold").text(recipientPurposeLabelText, 10, y)
      let lastIndex: number = linesMax - 1;
      while (h < linesMax) {
        let charCount: number = (h+1)*55;
        if (truncLength <= charCount) {
          charCount = truncLength;
        }
        let subPurposeTxt: string = truncDonorPurposeTxt.slice(h*55, charCount);
        if (h < lastIndex) {
          subPurposeTxt = subPurposeTxt + '-';
        }
        doc.setFont("Helvetica", "normal").text(subPurposeTxt, 55, y);
        y = y + 5;
        h = h + 1;
      }
      y = y + 5;
    } else {
      doc.setFont("Helvetica", "bold").text(recipientPurposeLabelText, 10, y)
        .setFont("Helvetica", "normal").text(this.recipientDonorPurposeTxt, 55, y);
      y = y + 10;
    }

    doc.setFont("Helvetica", "bold").text("Address: ", 10, y);
    y = y + 5;
    doc.setFont("Helvetica", "normal").text(this.recipientStreetAddress, 10, y);
    y = y + 5;
    doc.setFont("Helvetica", "normal").text(this.recipientCity + ", " + this.recipientState + ", " + this.recipientCountry + ", " + this.recipientZipCode, 10, y);
    y = y + 10;
    let recipientWebsiteUrlLabelText: string = "Website URL: ";
    doc.setFont("Helvetica", "bold").text(recipientWebsiteUrlLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.recipientWebsiteUrl, 55, y);
    y = y + 10;

    doc.setFontSize(16).setFont("Helvetica", "bold").text("Donor of Grant: ", 10, y);
    y = y + 10;
    doc.setFontSize(12);
    let donorNameLabelText: string = "Donor Name: ";
    doc.setFont("Helvetica", "bold").text(donorNameLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.donorOverviewRecord['companyName'], 55, y);
    y = y + 10;

    let donorWebsiteUrlLabelText: string = "Donor Website: ";
    doc.setFont("Helvetica", "bold").text(donorWebsiteUrlLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.donorOverviewRecord['websiteURL'], 55, y);
    y = y + 10;

    let donorPhoneNumberLabelText: string = "Donor Phone #: ";
    doc.setFont("Helvetica", "bold").text(donorPhoneNumberLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.formatPhoneNumber(this.donorOverviewRecord['phoneNumber']), 55, y);
    y = y + 10;

    doc.setFont("Helvetica", "bold").text("Donor Address: ", 10, y);
    y = y + 5;
    if (this.donorOverviewRecord['taxFilingStreetAddress']) {
      doc.setFont("Helvetica", "normal").text(this.donorOverviewRecord['taxFilingStreetAddress'], 10, y);
      y = y + 5;
      doc.setFont("Helvetica", "normal").text(this.donorOverviewRecord['taxFilingCity'] + ", " + this.donorOverviewRecord['taxFilingState'] + ", " + this.donorOverviewRecord['taxFilingCountry'] + ", " + this.donorOverviewRecord['taxFilingZipCode'], 10, y);
    } else {
      doc.setFont("Helvetica", "normal").text("N/A", 10, y);
    }
    y = y + 10;
    let donorFinancialsLabelText: string = "Donor Financials for ";
    doc.setFontSize(16).setFont("Helvetica", "bold").text(donorFinancialsLabelText +
      this.donorDetailsRecord.taxYear.toString(), 10, y);
    y = y + 10;

    doc.setFontSize(12);
    let donorTotalRevenueLabelText: string = "Total Revenue: ";
    doc.setFont("Helvetica", "bold").text(donorTotalRevenueLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.donorDetailsRecord['totalRevenueFormatted'],
      55, y);
    y = y + 5;

    let donorTotalExpensesLabelText: string = "Total Expenses: ";
    doc.setFont("Helvetica", "bold").text(donorTotalExpensesLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.donorDetailsRecord['totalExpensesFormatted'],
      55, y);
    y = y + 5;

    let donorTotalAssetsLabelText: string = "Total Assets: ";
    doc.setFont("Helvetica", "bold").text(donorTotalAssetsLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.donorDetailsRecord['totalAssetsFormatted'],
      55, y);
    y = y + 10;

    doc.addPage();
    y = 10;
    doc.setFont("Helvetica", "bold").text("Key Staff: ", 10, y);
    y = y + 10;
    //Insert Table
    let head: any[] = [["Name", "Title", "Phone Number"]];
    const body: any[] = [];
    for (const keyEmployee of this.donorDetailsRecord['keyEmployeesList']) {
      body.push([keyEmployee['personName'], keyEmployee['titleTxt'], keyEmployee['phoneNum']]);
    }
    autoTable(doc,{
      head: head,
      body: body,
      startY: y, // Start Y position
      theme: 'striped', // 'striped', 'grid', 'plain'
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0]
      }
    });
    doc.setFont("Helvetica", "normal").text(
      "Copyright Scalanthropy " + now.getFullYear().toString(), 150, 290);

    doc.save('grant_details_document.pdf');
  }
}
